// AlbumImageList.tsx
import * as React from "react";
import {
    ImageList, ImageListItem, ImageListItemBar, IconButton, Typography
} from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import CircularProgress from "@mui/material/CircularProgress";
import {PreviewImage} from "./AlbumImageUpload";
import {uploadAlbumPhoto} from "../../../Services/ApiCalls";
   // or wherever you put the type

type Props = {
    images: PreviewImage[];
    albumId: string;
    onUploaded?: (uploadedUrl: string, server: { photoId: string }) => void;
    onError?: (msg: string) => void;
};

export default function ImageListComp({ images, albumId, onUploaded, onError }: Props) {
    const [busyUrl, setBusyUrl] = React.useState<string | null>(null);

    const uploadOne = async (item: PreviewImage) => {
        console.log("Uploading", item.name);
        try {
            setBusyUrl(item.url);
            const res = await uploadAlbumPhoto(albumId, item.file, item.imagedesc ?? "");
            onUploaded?.(item.url, res);
        } catch (e: any) {
            onError?.(e?.message || "Upload failed");
        } finally {
            setBusyUrl(null);
        }
    };

    return (
        <ImageList sx={{ width: 500, maxHeight: 450 }}>
            {images.length === 0 ? (
                <ImageListItem key="empty">
                    <ImageListItemBar title="No images yet" subtitle="Select files to preview" />
                </ImageListItem>
            ) : (
                images.map((item) => (
                    <ImageListItem key={item.url}>
                        <img
                            src={item.url}
                            alt={item.name}
                            loading="lazy"
                            style={{ objectFit: "cover", width: "100%", height: "100%" }}
                        />
                        <ImageListItemBar
                            title={item.name}
                            subtitle={item.imagedesc ? <Typography variant="caption">{item.imagedesc}</Typography> : undefined}
                            actionIcon={
                                <IconButton
                                    sx={{ color: "rgba(255,255,255,0.85)" }}
                                    aria-label={`upload ${item.name}`}
                                    onClick={() => uploadOne(item)}
                                    disabled={busyUrl === item.url}
                                >
                                    {busyUrl === item.url ? <CircularProgress size={22} /> : <UploadIcon />}
                                </IconButton>
                            }
                        />
                    </ImageListItem>
                ))
            )}
        </ImageList>
    );
}